<script lang="ts">
    import Hero from "./Hero.svelte";
    import Loading from "./Loading.svelte";
</script>
<Hero class={$$restProps.class}>
    <Loading />
</Hero>
